var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3086 4.66044L10.7409 3.38282V1.33954C10.7409 1.10945 10.5537 0.922225 10.3236 0.922225H9.33725C9.10716 0.922225 8.91994 1.10945 8.91994 1.33954V1.89862L6.82529 0.191471C6.67376 0.0680221 6.47406 0 6.26298 0C6.05272 0 5.85397 0.0676048 5.70328 0.190409L0.220041 4.66041C-0.0290958 4.86341 -0.0141483 5.04024 0.0169226 5.12757C0.0479176 5.21471 0.147732 5.36092 0.467773 5.36092H1.2186V11.2392C1.2186 11.6588 1.55897 12 1.97735 12H4.34845C4.7633 12 5.08824 11.6658 5.08824 11.2392V8.82865C5.08824 8.62204 5.27811 8.43391 5.48658 8.43391H7.07996C7.27868 8.43391 7.44037 8.611 7.44037 8.82865V11.2392C7.44037 11.6516 7.79653 12 8.21809 12H10.5513C10.9696 12 11.31 11.6587 11.31 11.2392V5.36092H12.0608C12.3809 5.36092 12.4806 5.21471 12.5117 5.12757C12.5428 5.04024 12.5577 4.86341 12.3086 4.66044Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.369d3484ec3cff9b8216beee37077a34.svg";
export { ForwardRef as ReactComponent };